<div class="schedule-list-page">
  <header class="list-toolbar">
    <div class="search-cluster" #searchFilterWrap>
      <div class="search-wrap">
        <span class="material-symbols-outlined search-icon" aria-hidden="true">search</span>
        <input
          type="search"
          class="search-input"
          [placeholder]="searchPlaceholder"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchInput()"
          (keyup.enter)="onSearchSubmit()"
          [attr.aria-label]="searchAriaLabel"
        />
      </div>

      <div class="search-filter">
        <button
          type="button"
          class="filter-menu-btn"
          (click)="toggleFilterMenu(); $event.stopPropagation()"
          [attr.aria-expanded]="filterMenuOpen"
          aria-haspopup="true"
          aria-label="Search options"
        >
          <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
        </button>

        <div *ngIf="filterMenuOpen" class="filter-dropdown" role="menu" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="filter-dropdown__item"
            role="menuitemradio"
            [attr.aria-checked]="searchMode === 'suiteName'"
            (click)="setSearchMode('suiteName')"
          >
            Search by suite name
          </button>
          <button
            type="button"
            class="filter-dropdown__item"
            role="menuitemradio"
            [attr.aria-checked]="searchMode === 'scheduleName'"
            (click)="setSearchMode('scheduleName')"
          >
            Search by schedule name
          </button>
        </div>
      </div>
    </div>

    <div class="toolbar-actions">
      <a class="btn-new" routerLink="../create-schedule" [featureActionState]="'SCHEDULER'">
        <span class="material-symbols-outlined" aria-hidden="true">add</span>
        New Schedule
      </a>
    </div>
  </header>

  <div *ngIf="loading" class="state-message" role="status">Loading schedules…</div>

  <div *ngIf="!loading && errorMessage" class="state-message state-message--error" role="alert">
    {{ errorMessage }}
    <button type="button" class="btn-link" (click)="reload()">Retry</button>
  </div>

  <div *ngIf="!loading && !errorMessage" class="schedule-panel">
    <p *ngIf="!schedules.length" class="empty-message">No schedules found.</p>

    <div *ngIf="schedules.length" class="schedule-list-table" role="table">
      <div class="schedule-list-table__scroll">
      <div
        *ngFor="let schedule of schedules; trackBy: trackByScheduleId"
        class="schedule-row"
        role="row"
        [class.schedule-row--disabled]="isStatusDisabled(schedule.status)"
        [class.schedule-row--completed]="isStatusCompleted(schedule.status)"
        [class.schedule-row--menu-open]="isActionMenuOpen(schedule.id)"
      >
        <div class="schedule-main">
          <span
            class="status-dot"
            [class.status-dot--active]="isStatusActive(schedule.status)"
            [class.status-dot--disabled]="isStatusDisabled(schedule.status)"
            [class.status-dot--completed]="isStatusCompleted(schedule.status)"
            aria-hidden="true"
          ></span>
          <div class="schedule-text">
            <div class="schedule-name" [title]="schedule.schedule_name">{{ schedule.schedule_name }}</div>
            <div class="schedule-meta" [title]="getRecurrenceLabel(schedule)">{{ getRecurrenceLabel(schedule) }}</div>
            <div class="schedule-description" [class.schedule-description--empty]="!schedule.description" [title]="schedule.description || ''">{{ schedule.description }}</div>
          </div>
        </div>

        <span
          class="status-badge"
          [class.status-badge--active]="isStatusActive(schedule.status)"
          [class.status-badge--disabled]="isStatusDisabled(schedule.status)"
          [class.status-badge--completed]="isStatusCompleted(schedule.status)"
          [class.status-badge--access-revoked]="isStatusAccessRevoked(schedule.status)"
        >
          {{ getStatusLabel(schedule.status) }}
        </span>

        <span class="schedule-count">Count:&nbsp;{{ getTriggeredCount(schedule) }}</span>

        <div class="run-time-group">
          <div class="run-time-row" [title]="'Prev: ' + formatPreviousRunTime(schedule)">
            <span class="run-time-label">Prev:</span>
            <span class="run-time-value">{{ formatPreviousRunTime(schedule) }}</span>
          </div>
          <div class="run-time-row" [title]="'Next: ' + formatRunTime(schedule.next_run_time)">
            <span class="run-time-label">Next:</span>
            <span class="run-time-value">{{ formatRunTime(schedule.next_run_time) }}</span>
          </div>
        </div>

        <div class="row-actions" [class.row-actions--open]="isActionMenuOpen(schedule.id)">
          <div class="row-actions-menu">
            <button
              type="button"
              class="row-menu-btn"
              (click)="toggleActionMenu(schedule.id, $event)"
              [attr.aria-expanded]="isActionMenuOpen(schedule.id)"
              aria-haspopup="true"
              [attr.aria-label]="'Actions for ' + schedule.schedule_name"
              [featureActionState]="'SCHEDULER'"
            >
              <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
            </button>

            <div
              *ngIf="isActionMenuOpen(schedule.id)"
              class="row-menu-panel"
              [ngClass]="{'row-menu-panel--up': openMenuDirection === 'up'}"
              role="menu"
              (click)="$event.stopPropagation()"
            >
              <button
                *ngIf="isStatusActive(schedule.status)"
                type="button"
                class="row-menu-panel__item row-menu-panel__item--accent"
                role="menuitem"
                [disabled]="isRunningNow(schedule)"
                (click)="closeActionMenu(); onRunNow(schedule)"
                [featureActionState]="'SCHEDULER'"
              >
                <span class="material-symbols-outlined" aria-hidden="true">play_arrow</span>
                {{ isRunningNow(schedule) ? 'Running…' : 'Run now' }}
              </button>

              <button
                *ngIf="isStatusActive(schedule.status) || isStatusDisabled(schedule.status)"
                type="button"
                class="row-menu-panel__item"
                [class.row-menu-panel__item--warn]="isStatusActive(schedule.status)"
                role="menuitem"
                [disabled]="isTogglingStatus(schedule)"
                (click)="closeActionMenu(); onToggleStatus(schedule)"
                [featureActionState]="'SCHEDULER'"
              >
                <span class="material-symbols-outlined" aria-hidden="true">
                  {{ isStatusActive(schedule.status) ? 'pause_circle' : 'play_circle' }}
                </span>
                {{ isTogglingStatus(schedule) ? 'Updating…' : (isStatusActive(schedule.status) ? 'Disable' : 'Resume') }}
              </button>

              <button
                *ngIf="isStatusActive(schedule.status)"
                type="button"
                class="row-menu-panel__item"
                role="menuitem"
                (click)="closeActionMenu(); onEdit(schedule)"
                [featureActionState]="'SCHEDULER'"
              >
                <span class="material-symbols-outlined" aria-hidden="true">edit</span>
                Edit
              </button>

              <div class="row-menu-panel__divider" role="separator"></div>

              <button
                type="button"
                class="row-menu-panel__item row-menu-panel__item--danger"
                role="menuitem"
                [disabled]="isDeleting(schedule)"
                (click)="closeActionMenu(); onDelete(schedule)"
                [featureActionState]="'SCHEDULER'"
              >
                <span class="material-symbols-outlined" aria-hidden="true">delete</span>
                {{ isDeleting(schedule) ? 'Deleting…' : 'Delete' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <footer
    *ngIf="!loading && !errorMessage && totalCount > 0"
    class="list-pagination"
    aria-label="Schedule list pagination"
  >
    <span class="pagination-summary">
      Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }}
    </span>

    <div class="pagination-controls">
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage <= 1"
        (click)="goToPreviousPage()"
      >
        Previous
      </button>

      <span class="pagination-page">Page {{ currentPage }} of {{ totalPages }}</span>

      <button
        type="button"
        class="pagination-btn"
        [disabled]="!hasNext"
        (click)="goToNextPage()"
      >
        Next
      </button>
    </div>
  </footer>

  <div
    *ngIf="showDeleteConfirmModal"
    class="delete-modal-backdrop"
    role="presentation"
    (click)="cancelDelete()"
  >
    <div
      class="delete-modal"
      role="alertdialog"
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-desc"
      (click)="$event.stopPropagation()"
    >
      <h3 id="confirm-modal-title" class="delete-modal__title">Delete schedule?</h3>
      <p id="confirm-modal-desc" class="delete-modal__message">
        This will permanently delete <span id="schedule-name-warning">{{ schedulePendingDelete?.schedule_name }}</span>. This action cannot be undone.
      </p>
      <div class="delete-modal__actions">
        <button type="button" class="btn-modal btn-modal--ghost" (click)="cancelDelete()">
          Cancel
        </button>
        <button type="button" class="btn-modal btn-modal--danger" (click)="confirmDelete()">
          Delete
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showDeleteWarningModal"
    class="delete-modal-backdrop"
    role="presentation"
    (click)="cancelDeleteWarning()"
  >
    <div
      class="delete-modal"
      role="alertdialog"
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-desc"
      (click)="$event.stopPropagation()"
    >
      <h3 id="delete-modal-title" class="delete-modal__title">Delete schedule?</h3>
      <p id="delete-modal-desc" class="delete-modal__message">
        Less than 15 minutes remaining for the next execution of <span id="schedule-name-warning">{{ schedulePendingDelete?.schedule_name }}</span>. If you delete now,
        <strong>50% execution hours required for this schedule</strong> will be deducted.
      </p>
      <div class="delete-modal__actions">
        <button type="button" class="btn-modal btn-modal--ghost" (click)="cancelDeleteWarning()">
          Cancel
        </button>
        <button type="button" class="btn-modal btn-modal--danger" (click)="confirmDeleteWithWarning()">
          Delete anyway
        </button>
      </div>
    </div>
  </div>
</div>